import { render, staticRenderFns } from "./index_old.vue?vue&type=template&id=2638c866&scoped=true"
import script from "./index_old.vue?vue&type=script&lang=js"
export * from "./index_old.vue?vue&type=script&lang=js"
import style0 from "./index_old.vue?vue&type=style&index=0&id=2638c866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638c866",
  null
  
)

export default component.exports